import styled from "styled-components";

const StyledListContainer = styled.div`
    margin-top: 24px;
    border-radius: 8px;
    padding: 32px;
    background-color: #f0f2f2;
`;

const StyledHeaderContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;

const StyledTitleContent = styled.div`
    width: auto;
`;

const StyledGenerateTachContainer = styled.div`
    width: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: end;
    padding-bottom: 16px;
    align-content: flex-end;
    margin-top: 34px;
    margin-bottom: 24px;

    &.borderTopEmptyFolder {
        border-top: 1px solid #e4e4e4;
    }
`;

const StyledEmptyFolderContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    justify-items: center;
    align-content: center;
    align-items: center;
`;

const StyledEmptyFolder = styled.img`
    width: 100%;
    max-width: 416px;
    max-height: 410px;
`;

const StyledTitleEmptyFolder = styled.h3`
    font-family: Poppins;
    font-weight: 500;
    font-size: 24px;
    color: #333333;
`;

export {
    StyledListContainer,
    StyledHeaderContainer,
    StyledTitleContent,
    StyledGenerateTachContainer,
    StyledEmptyFolderContainer,
    StyledEmptyFolder,
    StyledTitleEmptyFolder,
};
